<template>
  <tr class="cabinet__tbody-row">
    <td class="cabinet__tbody-column">
      {{ item.id }}
    </td>
    <td class="cabinet__tbody-column">
      <p>{{ createdAt }}</p>
    </td>
    <td class="cabinet__tbody-column">
      <p>{{ item.type }}</p>
    </td>
    <td class="cabinet__tbody-column">
      {{ item.name }}
    </td>
    <td class="cabinet__tbody-column">
      {{ offlineDate }}
      <span class="cabinet__tbody-column--gray">
        {{ offlinePlace }}
      </span>
    </td>
    <td
      class="cabinet__tbody-column"
      v-html="onlineData"
    />
    <td class="cabinet__tbody-column">
      {{ item.settlement }}
    </td>
    <td class="cabinet__tbody-column">
      {{ item.object }}
    </td>
    <td class="cabinet__tbody-column">
      {{ item.project }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--status wk__textarea">
      {{ item.status }}
      <div
        class="cabinet__tbody-row__count-offer"
        :class="{'cabinet__tbody-row__count-offer--hover': offers.length}"
        @click=" offers.length ? isOpenPopup = true: false"
      >
        {{ declensionRequest(offers.length) }}
      </div>
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--actions">
      <div class="actions-container align-center">
        <router-link :to="routerData">
          <button class="action-item tooltip__list-item-img--show" />
        </router-link>
      </div>
    </td>
  </tr>

  <Popup
    v-model:value="isOpenPopup"
    title="Предложения участников"
    css-class="purchase-modal-items"
  >
    <div class="purchase-modal-items__list">
      <div class="purchase-modal-items__list-item">
        <div class="purchase-modal-items__list-item__label">
          Подано:
        </div>
        <div class="purchase-modal-items__list-item__value">
          {{ declensionRequest(offers.length) }}
        </div>
      </div>
      <br>
      <div
        v-for="(org,index) in item.offers"
        :key="org.organizationName"
        class="purchase-modal-items__list-item"
      >
        <div class="purchase-modal-items__list-item__label">
          Подрядчик {{ index + 1 }}:
        </div>
        <div class="purchase-modal-items__list-item__value">
          {{ org.organizationName }}
        </div>
      </div>

      <button
        class="search__button purchase-modal-items__btn"
        @click="isOpenPopup = false"
      >
        <span class="search__link">Закрыть</span>
      </button>
    </div>
  </Popup>
</template>

<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import Popup from '@/components/popup/popup.vue';

export default {
  name: 'ContractWorkTableItem',
  components: { Popup },
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isOpenPopup: false,
    };
  },
  methods: {
    declensionRequest(number) {
      if (!number) {
        return '';
      }
      const cases = [2, 0, 1, 1, 1, 2];
      return `${number} ${['заявка', 'заявки', 'заявок'][(number % 100 > 4 && number % 100 < 20) ? 2 : cases[Math.min(number % 10, 5)]]}`;
    },
  },
  computed: {
    ...mapState('appService', ['filterType']),
    createdAt() {
      return dayjs(this.item.createdAt).format('DD.MM.YYYY HH:mm');
    },
    offers() {
      return this.item?.offers || [];
    },
    onlineData() {
      if (this.item.type !== 'Онлайн') {
        return '-';
      }
      return `с ${dayjs(this.item.startDatetime).format('DD.MM.YYYY HH:mm')}<br> по ${dayjs(this.item.endDatetime).format('DD.MM.YYYY HH:mm')}`;
    },
    offlineDate() {
      if (this.item.type !== 'Очный') {
        return '';
      }
      return `${dayjs(this.item.endDatetime).format('DD.MM.YYYY HH:mm')}`;
    },
    offlinePlace() {
      if (this.item.type !== 'Очный') {
        return '-';
      }
      return `${this.item.offlinePlace}`;
    },
    routerData() {
      return { name: 'ContractWorkDetail', params: { id: this.item.id } };
    },
  },
};

</script>

<style lang="scss" scoped>
.actions-container {
  display: flex;
  gap: 8px;
}

.action-item {
  height: 22px;
  width: 22px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  appearance: none;
  border: 0;
  background-color: transparent;
}
</style>

<style lang="scss" scoped>
.actions-container {
  display: flex;
  gap: 8px;
}

.action-item {
  height: 22px;
  width: 22px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  appearance: none;
  border: 0;
  background-color: transparent;
}

.align-center {
  display: flex;
  justify-content: center;
}

.cabinet__tbody-column--gray {
  display: block;
  color: #808388;
  margin-top: 10px;
  font-weight: lighter;
}

.cabinet__tbody-row__count-offer {
  color: $color-green-primary;
  font-weight: normal;
}
</style>
